import Button from "@material-ui/core/Button";
import {CustomModal} from "../../../../../components/CustomModal";
import {ExportMemberAdminRebatesModal} from "./ExportMemberAdminRebatesModal";

export const ExportMemberAdminRebates = ({
  handleMemberAdminExportQuarter,
  handleMemberAdminExportYear,
  onExportMemberAdminRebates,
  rebates: {
    rebatesModalSpinner
  },
  memberAdminRebatesExportModal,
  memberAdminRebates: {
    isMemberAdminExport,
    exportQuarter,
    exportYear,
    memberQuartersList,
    memberYearsList,
  },
  memberProductList,
}) => {

  const closeModal = () => {
    memberAdminRebatesExportModal(false);
  };

  const quarterList = memberQuartersList ?? [];
  const yearList = memberYearsList ?? [];

  const child =
    <ExportMemberAdminRebatesModal
      handleMemberAdminExportQuarter={handleMemberAdminExportQuarter}
      handleMemberAdminExportYear={handleMemberAdminExportYear}
      exportQuarter={exportQuarter}
      exportYear={exportYear}
      quarterList={quarterList}
      yearList={yearList}
    />

  const isExportDisabled = memberProductList.length === 0

  return (
    <div>
      <Button
        onClick={() => memberAdminRebatesExportModal(true)}
        variant="contained"
        size="small"
        className={isExportDisabled ? "btn-add-blue button-disable" : "btn-add-blue"}
        disabled={isExportDisabled}
      >
        <span className="fas fa-file-export"></span>
        <span>Export</span>
      </Button>

      <CustomModal
        showModal={isMemberAdminExport}
        closeModal={closeModal}
        modalTitle={"Export Member Rebate Documents"}
        children={child}
        isCancelButton={true}
        isSubmitButton={false}
        isExportButton={true}
        isSubmitText={"Export"}
        onSubmit={onExportMemberAdminRebates}
        isLoading={rebatesModalSpinner}
      />
    </div>
  );
};
